<template>
  <div class="mt-2 ml-2 mr-2">
    <div v-if="isManager">
      <b-row>
        <b-col class="col">
          <b-card class="mb-2" border-variant="light" bg-variant="light">
            <p> Welcome to the Zooniverse Integration!<br>
              Connect your project with a related project at <a href="https://www.zooniverse.org/" target="_blank" rel="noopener noreferrer">Zooniverse</a>
              <span><i class="fas fa-external-link-alt fa-xs"></i></span>
              <br>
              Share photos from your CitSci Observations and have Zooniverse volunteers help classify your photos.</p>
            <br>
            <h6>Read more about this integration which uses the Panoptes API
              <a href="https://zooniverse.github.io/panoptes/?http#introduction" target="_blank" rel="noopener noreferrer">here</a>
              <span><i class="fas fa-external-link-alt fa-xs"></i></span>
            </h6>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="col-md-6 col-sm-12 mb-2" border-variant="light" bg-variant="light">
            <b-card-body>
              <b-row v-if="projectVuex.projectState" class="mb-3">
                <div class="mr-3"><b><u>Status:</u></b></div>
                <b-form-checkbox
                  v-model="projectVuex.isZooniverse"
                  :value=true
                  :unchecked-value=false
                  switch
                  size="lg">
                  <span>{{
                      projectVuex.isZooniverse ? 'Your Zooniverse Integration is turned ON' : 'Your Zooniverse Integration is turned OFF'
                    }}</span>
                </b-form-checkbox>
              </b-row>
              <b-row v-if="!projectVuex.projectState" class="mb-2">
                <div>
                  <b>Your project needs to be Published before the Zooniverse integration can be turned ON.<br>
                  Publish your project in
                  <b-link :to="{ name: 'ProjectEdit', params: { id: $route.params.id }}">Edit Project</b-link> tab</b>
                </div>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <div v-if="projectVuex && projectVuex.projectState && projectVuex.isZooniverse" class="card-body">
        <div class="mb-4">
          <b-button
              class="btn btn-sm dropdown-toggle mb-2"
              @click="collapse = !collapse"
              variant="secondary"
              h-align="center"
          >
            <font-awesome-icon icon="info"/>
            &emsp;How to integrate with Zooniverse
          </b-button>
          <div v-show="!collapse">
            <ol>
              <li v-if="!userVuex.zooniverseUsername">Enter your Zooniverse Username.</li>
              <li v-if="!userVuex.zooniverseUsername">Click on '<b>Look Up Username</b>' to verify your Zooniverse Username.*</li>
              <li v-else>Double check that your Zooniverse Username is correct. If not correct, go <a href="http://bit.ly/citscifaq">here</a> to send a name change help request.</li>
              <li v-if="!projectVuex.zooniverseUserName">Click on '<b>Associated Username</b>' to link your Zooniverse username to this project.</li>
              <li v-if="!projectVuex.zooniverseID">Click on '<b>Create Zooniverse Project</b>'.*</li>
              <li v-else>(Optional) You can verify your Zooniverse project was successfully created by clicking on '<b>Visit Zooniverse Project</b>'</li>
              <li>When you are ready to transfer a datasheet's observations images:</li>
                <ol type="a">
                  <li>Click on '<b>Pick a Datasheet...</b>' and choose your datasheet.</li>
                  <li>Click on '<b>Transfer images to Zooniverse</b>' to send new images over to Zooniverse.*  If this is the first time images are sent for the chosen datasheet, a corresponding Subject Set will be created on Zooniverse.  Each datasheet's images will be placed in its corresponding Subject Set.  Images previously sent will NOT be resend.</li>
                  <li>Verify the images were successfully sent by clicking on '<b>Visit Zooniverse Project</b>' to open a new window and view your images in the corresponding Zooniverse Subject Set.</li>
                </ol>
            </ol>
            * This step may take a few seconds.  When successful, the information will be updated.
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-6">
            <ZooniverseUsername></ZooniverseUsername>
          </div>
          <div class="col-6">
            <ZooniverseProject></ZooniverseProject>
          </div>
        </div>
        <div class="row justify-center mt-4">
          <div class="card col-8 p-0">
            <DatasheetSelection></DatasheetSelection>
          </div>
        </div>
      </div>
    </div>
    <RequiresManager v-else page="Zooniverse Integration"></RequiresManager>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import RequiresManager from "../tabpermission/requiresManager.vue";
import ZooniverseUsername from './username.vue'
import ZooniverseProject from "./project.vue";
import DatasheetSelection from "./datasheetSelection.vue";

export default {
  name: "Zooniverse",
  props: {},
  components: {
    RequiresManager,
    ZooniverseUsername,
    ZooniverseProject,
    DatasheetSelection,
  },
  data() {
    return {
      collapse: true,
    };
  },
  created() { },
  computed: {
    ...mapGetters({
      isManager: "project/get/isManager",
      isLoading: "project/get/isLoading",
      projectVuex: "project/get/project",

      userVuex: 'user/profile/sessionData',
      history: "project/get/zooniverse/historyForDatasheet",
      isLoadingUser: "project/get/zooniverse/isLoadingUser",
      isLoadingProjectId: "project/get/zooniverse/isLoadingProjectId",
      isLoadingDatasheets: "project/get/zooniverse/isLoadingDatasheets",
      messageLoadingUser: "project/get/zooniverse/messageLoadingUser",
      messageLoadingProject: "project/get/zooniverse/messageLoadingProject",
      messageLoadingDatasheets:
          "project/get/zooniverse/messageLoadingDatasheets"
    }),
  },

  watch: {
    'projectVuex.isZooniverse'(newValue) {
      this.editProject({isZooniverse: this.projectVuex.isZooniverse});
    },
  },

  methods: {
    ...mapActions({
      editProject: "project/update/editProject",
    }),
  }
};
</script>

<style lang="scss" scoped></style>
